import resolve from "ioc/resolve";
import templateUrl from "webmodals/dialog.htm";
import open from "webmodals/open";

export default (config) => {
  const options = Object.assign(
    {
      backdrop: "static",
      closeButton: "dismiss",
      templateUrl,
    },
    config
  );

  function done(key) {
    options.buttons[key] &&
      options.buttons[key].handler &&
      options.buttons[key].handler(key, options.buttons[key]);
    return key;
  }

  const instance = open({
    backdrop: options.backdrop,
    closeButton: options.closeButton,
    templateUrl: options.templateUrl,
    controller: options.controller,
    size: options.size,
    scope: Object.assign(resolve("$rootScope").$new(), options, {
      closeButtonClick(closeButton) {
        instance[closeButton]();
      },
      dialogButtonClick(key, button) {
        instance[button.dismiss ? "dismiss" : "close"](key, button);
      },
    }),
  });

  instance.result.then(done, done);

  return instance;
};
